module.exports = __webpack_public_path__ + "static/media/usdt.66f1b147.svg";